import classNames from 'classnames';

import Svg from '../../../svg/svg.component';

interface QuoteIconProps {
  isInverse?: boolean;
}

export const QuoteIcon = ({ isInverse }: QuoteIconProps) => {
  return (
    <Svg
      name="quote"
      data-testid="snowflake-quote-carousel-item-quote-icon"
      className={classNames('snowflake-quote-carousel-item-quote-icon', {
        'snowflake-quote-carousel-item-quote-icon-flipped': isInverse,
      })}
    />
  );
};
